module.exports = __webpack_public_path__ + "static/media/user-badge-avatar.a6ebb104.svg";